<div class="mb-3">
    <div class="table-header fw-bold py-2 d-flex flex-row flex-nowrap">
        <div class="col-2 col-lg-1 px-2" translate="CONFIRMATION_PARTICIPANTLIST_TITLE_LABEL"></div>
        <div class="col px-2" translate="CONFIRMATION_PARTICIPANTLIST_FIRSTNAME_LABEL"></div>
        <div class="col px-2" translate="CONFIRMATION_PARTICIPANTLIST_LASTNAME_LABEL"></div>
        <div class="d-none d-lg-block col px-2" translate="CONFIRMATION_PARTICIPANTLIST_EMAIL_LABEL"></div>
        <div
            *ngIf="displayMobileNumber"
            class="d-none d-lg-block col px-2"
            translate="CONFIRMATION_PARTICIPANTLIST_MOBILE_NUMBER_LABEL"
        ></div>
    </div>
    <ng-container *ngIf="participants.length > 0">
        <div *ngFor="let participant of participants" class="table-row py-2">
            <div class="d-flex flex-row">
                <div class="col-2 col-lg-1 px-2">{{ participant.title.value }}</div>
                <div class="col px-2">{{ participant.firstName.value }}</div>
                <div class="col px-2">{{ participant.lastName.value }}</div>
                <div class="d-none d-lg-block col px-2">{{ participant.mail.value }}</div>
                <div class="d-none d-lg-block col px-2" *ngIf="displayMobileNumber">
                    {{ participant.mobileNumber.value }}
                </div>
            </div>
            <div class="d-block d-lg-none col-12 my-1">
                <label class="col-4 px-2 col-form-label" translate="CONFIRMATION_PARTICIPANTLIST_EMAIL_LABEL"></label>
                <div class="col-8 px-2">
                    <span class="form-control-plaintext">{{ participant.mail.value }}</span>
                </div>
                <label
                    *ngIf="displayMobileNumber"
                    class="col-4 px-2 col-form-label"
                    translate="CONFIRMATION_PARTICIPANTLIST_MOBILE_NUMBER_LABEL"
                ></label>
                <div class="col-8 px-2" *ngIf="displayMobileNumber">
                    <span class="form-control-plaintext">{{ participant.mobileNumber.value }}</span>
                </div>
            </div>
        </div>
    </ng-container>
    <div *ngIf="participants.length === 0" class="table-row py-2">
        <div class="d-flex flex-row">
            <label class="col px-2" translate="CONFIRMATION_SUMMARY_PARTICIPANT_NOT_AVAILABLE"></label>
        </div>
    </div>
</div>
